import { ArrowRight, Bell } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function AteliersFinalCTA({ onRegister, onNotify }) {
  return (
    <section
      data-testid="ateliers-final-cta"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="relative rounded-[2.5rem] bg-[#3A2E6E] text-white p-12 md:p-20 text-center overflow-hidden">
            <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[30rem] h-[30rem] rounded-full bg-[#C98FA3]/25 blur-[120px] pointer-events-none" />
            <div className="absolute -bottom-32 right-0 w-[28rem] h-[28rem] rounded-full bg-[#2847B8]/30 blur-[120px] pointer-events-none" />

            <span className="relative text-sm uppercase tracking-[0.22em] text-[#C98FA3] font-medium">
              — Inscription
            </span>
            <h2 className="relative font-serif-display text-5xl md:text-6xl font-light mt-5 leading-[1.02] text-white">
              Réserver votre place
            </h2>
            <p className="relative mt-6 max-w-2xl mx-auto text-lg text-white/80 leading-relaxed">
              Les places étant limitées, il est conseillé de s'inscrire à l'avance.
            </p>

            <div className="relative mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={onRegister}
                data-testid="ateliers-final-register"
                className="group bg-white text-[#3A2E6E] hover:bg-[#E6D6DF] transition-all duration-300 rounded-full px-8 py-4 font-medium inline-flex items-center justify-center gap-2"
              >
                S'inscrire maintenant
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                onClick={onNotify}
                data-testid="ateliers-final-notify"
                className="border-2 border-white/30 text-white hover:bg-white/10 transition-all duration-300 rounded-full px-8 py-4 font-medium inline-flex items-center justify-center gap-2"
              >
                <Bell className="w-4 h-4" />
                Être informé
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
